import { onLCP, onCLS, onINP } from 'web-vitals';

import { trackCoreWebVitalsPerformance } from './trackCoreWebVitalsPerformance';

import type { Metric } from 'web-vitals';

const emitEvent = (metric: Metric) => {
  trackCoreWebVitalsPerformance(metric);
};

export const setupCoreWebVitalsMonitoring = () => {
  onLCP(emitEvent);
  onCLS(emitEvent);
  onINP(emitEvent);
};
